module.exports = __webpack_public_path__ + "static/media/info.2176c5fc.svg";